var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t12,5.9 15.5,7.9 12,9.9 \t","key":0}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4,9.9 0.5,7.9 4,5.9 \t","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.6","y1":"2.2","x2":"4.4","y2":"13.8","key":2})]));
}

Code.displayName = "Code";

Code.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Code;

Code.default = Code;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/code.svg
// module id = ../icon/src/icons/code.svg
// module chunks = 0